








































import Vue from 'vue';
import * as api from '@/api';
import { jobs } from './enum.js';

export default Vue.extend({
    computed: {
        summarys() {
            const summarys = this.$store.state.userSummary;
            return Object.keys(summarys).map((item) => ({ key: item, count: summarys[item] }));
        },
    },
    data() {
        return {
            jobs,
            items: {
                collectedCount: { name: '我的收藏', path: '/user/collect' },
                toBeUpdatedCount: { name: '待更新', path: '/user/tobeUpdate' },
                downloadedCount: { name: '已下载', path: '/user/downloaded' },
                brandCount: { name: '品牌', path: '/user/brand' },
            },
            user: {
                avatar: '',
                nickname: '',
                phone: '',
                location: '',
                campany: '',
                profession: '',
                userName: '',
            },
        };
    },
    filters: {
        userInfoNull(val) {
            if (val) {
                return val;
            }
            return '--';
        },
    },
    watch: {
        summary(val) {
            this.items[0].count = val.collectedCount;
            this.items[1].count = val.toBeUpdatedCount;
            this.items[2].count = val.downloadedCount;
            this.items[3].count = val.brandCount;
        },
    },
    async created() {
        const userRes: api.User = this.$store.state.user;
        const location = (userRes.province && userRes.city) ? `${userRes.province} - ${userRes.city}` : '';
        this.user.avatar = userRes.avatar;
        this.user.nickname = userRes.nickName;
        this.user.phone = userRes.phoneNumber;
        this.user.location = location;
        this.user.campany = userRes.organization;
        this.user.profession = userRes.profession;
        this.user.userName = userRes.userName;
    },
    methods: {
        async getPrefecture(parentCode) {
            const resp = await api.getRegions({ parentCode });
            if (!api.error(resp)) {
                return resp.data;
            }
            return [];
        },
    },
});
